import React, { useState } from 'react';
import styles from './influencerSec.module.css';
import { motion, AnimatePresence } from 'framer-motion';
import useTextAnimation from "../../hooks/useTextAnimation.js";
import { IMAGE_URL } from '../../helpers/api_helper.jsx';
import { useTranslation } from 'react-i18next';
import '../../../i18n';
import { LANG_EN } from '../../helpers/constant';

const InfluencerSecondSec = ({ partnerData, influencerData }) => {
    //const itemsPerRow = 12;
    const itemsPerRow = 6; // Each row should have 6 images
    const initialRows = 3; // Show 3 rows by default
    const [visibleCount, setVisibleCount] = useState(itemsPerRow * initialRows);
    const [showAll, setShowAll] = useState(false);

    const { ref: headingRef, inView: headingInView, textAnimation } = useTextAnimation();
    const { t, i18n } = useTranslation();

    /* const toggleShowMore = () => {
        if (showAll) {
            setVisibleCount(itemsPerRow);
        } else {
            setVisibleCount(partnerData.length);
        }
        setShowAll(!showAll);
    }; */

    const toggleShowMore = () => {
        if (showAll) {
            setVisibleCount(itemsPerRow * initialRows); // Show initial 3 rows
        } else {
            setVisibleCount(partnerData.length); // Show all remaining images
        }
        setShowAll(!showAll);
    };

    return (
        <div className={styles.influencerParSec}>
            <div className={styles.influencerParSecT}>
                <motion.h3
                    ref={headingRef}
                    initial="hidden"
                    animate={headingInView ? "visible" : "hidden"}
                    custom={0}
                    variants={textAnimation}
                    dangerouslySetInnerHTML={{
                        __html: i18n.language === LANG_EN ? influencerData?.partnerTitle : influencerData?.partnerTitleAr
                    }}
                />
            </div>
            <div className={styles.influencerParSecP}>
                <motion.p
                    ref={headingRef}
                    initial="hidden"
                    animate={headingInView ? "visible" : "hidden"}
                    custom={0}
                    variants={textAnimation}
                    dangerouslySetInnerHTML={{
                        __html: i18n.language === LANG_EN ? influencerData?.partnerDesc : influencerData?.partnerDescAr
                    }}
                />
            </div>
            <div className={styles.influencerParSecImg}>
                <ul className={styles.influencerParSecImgs}>
                    <AnimatePresence>
                        {partnerData.slice(0, visibleCount).map((img, index) => (
                            <motion.li
                                key={index}
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                transition={{ duration: 0.5 }}
                            >
                                <img src={`${IMAGE_URL}/partners/${img.image}`} alt={`Partner ${index + 1}`} loading='lazy' />
                            </motion.li>
                        ))}
                    </AnimatePresence>
                </ul>
                {partnerData.length > itemsPerRow && (
                    <motion.button
                        className={styles.showMoreBtn}
                        onClick={toggleShowMore}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.3 }}
                    >
                       {showAll ? t('seeLess') : t('seeMore')}

                    </motion.button>
                )}
            </div>
        </div>
    );
};

export default InfluencerSecondSec;
